import { put, call } from 'redux-saga/effects';
import { Types } from './actions';
import PlanProgressDataRepository from '../../../data/repositories/PlanProgressDataRepository';
import PlanProgressRepository from '../../repositories/PlanProgressRepository';

export default function* execute(action: any): any {
  try {
    const { courseId, courseList } = action;
    yield put({ type: Types.GET_PLAN_PROGRESS_EQUIVALENCES_REQUEST });

    const planProgressDataRepository: PlanProgressRepository =
      new PlanProgressDataRepository();

    const planProgressResponse = yield call(
      planProgressDataRepository.getPlanProgressEquivalences,
      courseId,
      courseList
    );

    yield put({
      type: Types.GET_PLAN_PROGRESS_EQUIVALENCES_SUCCESS,
      data: planProgressResponse
    });
  } catch (error) {
    yield put({
      type: Types.GET_PLAN_PROGRESS_EQUIVALENCES_FAILURE,
      error: 'Ocurrió un error.'
    });
  }
}
